import {
  TOKENS,
  SAMPLE_LINK_URL,
  SAMPLE_FIRST_NAME,
  COMPLIANCE_SEPARATOR_LENGTH,
  MAX_BODY_LEN,
  ORG_PREFIX_FALLBACK,
  STOP_SUFFIX,
} from './constants';
import { countSmsSegments } from './smsEncoding';

export const hasLinkToken = (body) => body.includes(TOKENS.LINK);

export const hasFirstNameToken = (body) => body.includes(TOKENS.FIRST_NAME);

const tokenCount = (body, token) => body.split(token).length - 1;

export const hasDuplicateTokens = (body) => (
  tokenCount(body, TOKENS.LINK) > 1 || tokenCount(body, TOKENS.FIRST_NAME) > 1
);

const substituteBody = (body) => {
  const withLink = body.split(TOKENS.LINK).join(SAMPLE_LINK_URL);
  return withLink.split(TOKENS.FIRST_NAME).join(SAMPLE_FIRST_NAME);
};

const formatOrgPrefix = (coachName) => (coachName ?? '').trim().replace(/\s+/g, ' ') || ORG_PREFIX_FALLBACK;

// The three parts Brevo bills for, in order. Sole definition of the wrapping shape.
const complianceSegments = (body, { coachName } = {}) => (
  [formatOrgPrefix(coachName), substituteBody(body), STOP_SUFFIX]
);

// Drops the empty segment so an empty body doesn't render a blank line.
export const substituteForPreview = (body, options) => (
  complianceSegments(body, options).filter(Boolean).join('\n')
);

export const substitutedLength = (body, options) => (
  complianceSegments(body, options).reduce((total, segment) => total + segment.length, 0)
  + COMPLIANCE_SEPARATOR_LENGTH
);

export const substitutedSegments = (body, options) => countSmsSegments(
  substituteForPreview(body, options),
  substitutedLength(body, options),
);

// Mirrors the server's validateCampaignTemplate: dpl present, no duplicate tokens, within budget.
export const isBodySendable = (body, length) => (
  hasLinkToken(body) && !hasDuplicateTokens(body) && length <= MAX_BODY_LEN
);

// Replaces the current selection with `text` and reports where the caret should land.
// Used for both the {dpl}/{firstName} chips and emoji picked from the picker.
export const insertAtCursor = (body, text, selectionStart, selectionEnd) => {
  const safeStart = Math.max(0, Math.min(selectionStart ?? body.length, body.length));
  const safeEnd = Math.max(safeStart, Math.min(selectionEnd ?? safeStart, body.length));
  const before = body.slice(0, safeStart);
  const after = body.slice(safeEnd);
  return {
    body: `${before}${text}${after}`,
    caret: safeStart + text.length,
  };
};
